import React, { useEffect } from 'react';
import useSetState from '../../hooks/useSetState';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../../components/table';
import { regionsListColumns } from '../../enums/columns/regionsList';
import cookies from 'js-cookie';
import {
  getAllRegionsNames,
  getRegionsList,
} from '../../redux/regions/actions';
import AddOrEditRegion from './addOrEditRegion/AddOrEditRegion';
import ShowForPermission from '../../components/ShowForPermission';
import ENUMS from '../../enums';
import submitForm from '../../utils/submitForm';

const RegionsList = props => {
  let dispatch = useDispatch();

  const [controls, setControls] = useSetState({
    sort: { sortType: 'desc', sortBy: 'name', sortQuery: '', filterQuery: '' },
    pageNumber: 1,
    pageSize: 15,
    name: '',
    cityName: '',
    cityId: '',
    cityCode: '',
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const {
    regionsList,
    regionsNames,
    regionsListTotalRecords,
    getRegionsListLoading,
  } = useSelector(state => ({
    regionsList: state.regionsReducer.regionsList,
    regionsNames: state.regionsReducer.regionsNames,
    getRegionsListLoading: state.regionsReducer.getRegionsListLoading,
    regionsListTotalRecords: state.regionsReducer.regionsListTotalRecords,
  }));

  const sortTable = columnName => {
    const sortType = controls.sort.sortType === 'asc' ? 'desc' : 'asc';
    onChangeValue('sort', { ...controls.sort, sortType, sortBy: columnName });
  };

  const buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&sort=${controls.sort.sortQuery || 'startDate-desc'}`;
      if (controls.sort.filterQuery) {
        query += '&' + controls.sort.filterQuery;
      }
      return query;
    }
  };

  const onPageChanged = pageNumber => {
    onChangeValue('pageNumber', pageNumber);
    let id = controls.cityId;
    const query = buildSearchQuery(pageNumber, controls.pageSize);
    dispatch(getRegionsList(id, query));
  };

  const filterAndSort = () => {
    let id = controls.cityId;
    let searchQuery = buildSearchQuery(1, controls.pageSize);
    dispatch(getRegionsList(id, searchQuery));
  };

  const onSubmit = event => {
    event.preventDefault();
    const queryString = submitForm(event, controls.name);
    onChangeValue('sort', { ...controls.sort, filterQuery: queryString });
  };

  const resetForm = () => {
    onChangeValue('pageNumber', 1);
    onChangeValue('name', '');
    onChangeValue('sort', { ...controls.sort, filterQuery: '' });
    let query = `pageNumber=${1}&pageSize=${controls.pageSize}`;
    query += `&sort=${controls.sort.sortQuery || 'startDate-desc'}`;
    let id = controls.cityId;
    dispatch(getRegionsList(id, query));
  };

  useEffect(() => {
    let cityCode;
    if (props.location.redirect) {
      cityCode = props.location.item.cityCode;
      cookies.set('region-of-city', props.location.item.name);
      cookies.set('regionsCityCode', props.location.item.cityCode);
      cookies.set('cityId', props.location.item.id);
      onChangeValue('cityName', props.location.item.name);
      onChangeValue('cityId', props.location.item.id);
      onChangeValue('cityCode', props.location.item.cityCode);
    } else {
      let city = cookies.get('region-of-city');
      let id = cookies.get('cityId');
      cityCode = cookies.get('regionsCityCode');
      onChangeValue('cityName', city);
      onChangeValue('cityId', id);
      onChangeValue('cityCode', cityCode);
    }

    let data = {
      cityCode: cityCode,
    };
    dispatch(getAllRegionsNames(data));
  }, [props]);

  useEffect(() => {
    const sortQuery = `${controls.sort.sortBy}-${controls.sort.sortType}`;
    onChangeValue('sort', { ...controls.sort, sortQuery });
  }, [controls.sort.sortType]);

  useEffect(() => {
    if (controls.sort.sortQuery !== '') {
      onChangeValue('pageNumber', 1);
      filterAndSort();
    }
  }, [controls.sort.sortQuery]);

  useEffect(() => {
    if (controls.sort.filterQuery !== '') {
      onChangeValue('pageNumber', 1);
      filterAndSort();
    }
  }, [controls.sort.filterQuery]);

  return (
    <section>
      <div className='col-12 d-flex justify-content-between align-items-center'>
        <h3 className='text-right text-muted py-4'>
          {locales('see.regions.list')}
          &nbsp;{`${controls.cityName}`}
        </h3>
        <AddOrEditRegion cityId={controls.cityId} regionsNames={regionsNames} />
      </div>

      <section className='regions-filters'>
        <form
          onSubmit={event => onSubmit(event)}
          id='filterForm'
          className='card card my-4'
        >
          <header className='text-center card-header'>
            <h5 className='font-italic text-muted'>
              {locales('titles.filter')}
            </h5>
          </header>
          <main className='card-body'>
            <div className='d-flex row flex-sm-column col-12 flex-md-row justify-content-between px-1 mx-1'>
              <div
                className={`d-flex col-lg-8 col-md-12 col-sm-12 align-items-center`}
              >
                <ShowForPermission
                  permission={ENUMS.PERMISSIONS.values.VIEW_REGIONS_LIST}
                >
                  <label className='col-3 rsee-form-label text-right'>
                    {locales('region.name')}
                  </label>
                  <div className='full-width'>
                    <input
                      className='form-control col-12'
                      type='text'
                      id='name'
                      name='name'
                      placeholder={locales('region.Name')}
                      onChange={e => onChangeValue('name', e.target.value)}
                      value={controls.name}
                    />
                  </div>
                </ShowForPermission>
              </div>
            </div>

            <div className='col-12 d-flex justify-content-end p-0 my-3'>
              <button
                type='button'
                onClick={resetForm}
                className='btn btn-danger w-5 mx-2'
              >
                {locales('fields.reset')}
              </button>
              <button type='submit' className='btn btn-success w-5 mx-2'>
                {locales('fields.applyFilters')}
              </button>
            </div>
          </main>
        </form>
      </section>

      <div className='bg-white p-2'>
        <div className='bg-white p-2'>
          <div className='panel-heading'>
            <i className='fas fa-list-alt px-1' />
            {locales('regions.list')}
          </div>
          <div className='table-responsive-lg'>
            <Table
              columns={regionsListColumns}
              dataSource={regionsList}
              loading={getRegionsListLoading}
              sort={{ type: controls.sort.sortType, action: sortTable }}
              pagination={{
                currentPage: controls.pageNumber,
                pageSize: controls.pageSize,
                totalCount: regionsListTotalRecords || 0,
                onPageChange: onPageChanged,
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegionsList;
